import React from 'react'

import { Hidden } from '@material-ui/core'

const Desktop: React.FC = ({ children }) => {
  return <Hidden smDown>{children}</Hidden>
}

export default Desktop
